"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitOnChainFuelAttestationResponseStatusEnum = exports.SubmitOnChainFuelAttestationResponseToJSON = exports.SubmitOnChainFuelAttestationResponseFromJSONTyped = exports.SubmitOnChainFuelAttestationResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
function SubmitOnChainFuelAttestationResponseFromJSON(json) {
    return SubmitOnChainFuelAttestationResponseFromJSONTyped(json, false);
}
exports.SubmitOnChainFuelAttestationResponseFromJSON = SubmitOnChainFuelAttestationResponseFromJSON;
function SubmitOnChainFuelAttestationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'success': !(0, runtime_1.exists)(json, 'success') ? undefined : json['success'],
        'attestationId': !(0, runtime_1.exists)(json, 'attestationId') ? undefined : json['attestationId'],
        'fuelAmount': !(0, runtime_1.exists)(json, 'fuelAmount') ? undefined : json['fuelAmount'],
        'estimatedUsdValue': !(0, runtime_1.exists)(json, 'estimatedUsdValue') ? undefined : json['estimatedUsdValue'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : json['status'],
        'message': !(0, runtime_1.exists)(json, 'message') ? undefined : json['message'],
    };
}
exports.SubmitOnChainFuelAttestationResponseFromJSONTyped = SubmitOnChainFuelAttestationResponseFromJSONTyped;
function SubmitOnChainFuelAttestationResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'success': value.success,
        'attestationId': value.attestationId,
        'fuelAmount': value.fuelAmount,
        'estimatedUsdValue': value.estimatedUsdValue,
        'status': value.status,
        'message': value.message,
    };
}
exports.SubmitOnChainFuelAttestationResponseToJSON = SubmitOnChainFuelAttestationResponseToJSON;
/**
* @export
* @enum {string}
*/
var SubmitOnChainFuelAttestationResponseStatusEnum;
(function (SubmitOnChainFuelAttestationResponseStatusEnum) {
    SubmitOnChainFuelAttestationResponseStatusEnum["PENDINGREVIEW"] = "PENDING_REVIEW";
})(SubmitOnChainFuelAttestationResponseStatusEnum = exports.SubmitOnChainFuelAttestationResponseStatusEnum || (exports.SubmitOnChainFuelAttestationResponseStatusEnum = {}));
